import { memo } from "react";
import { motion, useScroll, useSpring, useReducedMotion } from "framer-motion";

function ScrollProgressComponent() {
  const prefersReducedMotion = useReducedMotion();
  const { scrollYProgress } = useScroll();
  
  // Optimized spring config for smoother performance
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 80,
    damping: 25,
    restDelta: 0.001,
    mass: 0.5,
  });

  // Don't render if user prefers reduced motion
  if (prefersReducedMotion) return null;

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[2px] z-[200] origin-left bg-gradient-to-r from-white via-gray-400 to-white gpu-layer"
      style={{ 
        scaleX,
        willChange: "transform",
      }}
    />
  );
}

const ScrollProgress = memo(ScrollProgressComponent);
export default ScrollProgress;
